import Skeleton from "features/ui/Skeleton";

const SkeletonLoader = () => (
  <div className="flex flex-col gap-4 p-6">
    <div className="col-span-2">
      <Skeleton height={100} className="w-full" />
    </div>

    <div className="flex flex-row gap-4 h-[600px]">
      <Skeleton height="100%" className="h-full flex-1" />
      <Skeleton height="100%" className="h-full flex-1" />
    </div>

    <div className="flex flex-col gap-4">
      <Skeleton width="100%" height={100} />
      <Skeleton width="100%" height={200} />
      <Skeleton width="100%" height={150} />
    </div>
  </div>
);

export default SkeletonLoader;
